import { render } from "./TotalesTerminados.vue?vue&type=template&id=622d7cb5&scoped=true"
import script from "./TotalesTerminados.vue?vue&type=script&lang=js"
export * from "./TotalesTerminados.vue?vue&type=script&lang=js"

import "./TotalesTerminados.vue?vue&type=style&index=0&id=622d7cb5&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/Laravel/mistock/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622d7cb5"]])

export default __exports__